import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ScheduleTimeComponent } from './schedule-time.component';

@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        ScheduleTimeComponent,
    ],
    providers: [],
    exports: [
        ScheduleTimeComponent,
    ]
})
export class ScheduleTimeModule {}
